import { render } from "./AuthPrefPin.vue?vue&type=template&id=549072da&scoped=true&ts=true"
import script from "./AuthPrefPin.vue?vue&type=script&lang=ts"
export * from "./AuthPrefPin.vue?vue&type=script&lang=ts"

import "./AuthPrefPin.vue?vue&type=style&index=0&id=549072da&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-549072da"]])

export default __exports__